(function(){
  if (window.__rsCountdownShortcodeLoaded) return;
  window.__rsCountdownShortcodeLoaded = true;

  var STYLE_ID = 'rs-countdown-shortcode-style';
  function addStyle(){
    if (document.getElementById(STYLE_ID)) return;
    var css = '.rs-countdown-shortcode{display:flex;align-items:center;gap:7px;flex-wrap:wrap;margin:14px 0 12px;font-weight:700;color:#333;clear:both}.rs-countdown-shortcode .rs-countdown-box{display:inline-block;min-width:34px;padding:5px 7px;border:1px solid #333;background:#fff;text-align:center;font-size:16px;line-height:1.1}.rs-countdown-shortcode .rs-countdown-label{font-size:12px;margin-left:2px;margin-right:7px;color:#333;font-weight:600}.rs-countdown-shortcode.rs-countdown-expired-placeholder{display:block;height:18px;margin:8px 0 10px;padding:0;line-height:18px;font-size:0;border:0;background:transparent}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function parseDate(raw){
    raw = (raw || '').trim();
    var normalized = raw.replace(/-/g, '/');
    var d = new Date(normalized);
    if (isNaN(d.getTime())) d = new Date(raw);
    return isNaN(d.getTime()) ? null : d;
  }

  function pad(n){ return String(Math.max(0, n)).padStart(2, '0'); }

  function render(el){
    var target = parseDate(el.getAttribute('data-countdown-target'));
    if (!target) return;

    // Expired pre-sale: hide 0d 00h 00m 00s, keep one blank line for spacing.
    if (target.getTime() <= Date.now()) {
      el.innerHTML = '';
      el.classList.add('rs-countdown-expired-placeholder');
      el.setAttribute('aria-hidden', 'true');
      return;
    }

    function tick(){
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        el.innerHTML = '';
        el.classList.add('rs-countdown-expired-placeholder');
        el.setAttribute('aria-hidden', 'true');
        clearInterval(timer);
        return;
      }
      var total = Math.floor(diff / 1000);
      var days = Math.floor(total / 86400);
      var hours = Math.floor((total % 86400) / 3600);
      var mins = Math.floor((total % 3600) / 60);
      var secs = total % 60;
      el.innerHTML = '<span class="rs-countdown-box">' + days + '</span><span class="rs-countdown-label">d</span>' +
        '<span class="rs-countdown-box">' + pad(hours) + '</span><span class="rs-countdown-label">h</span>' +
        '<span class="rs-countdown-box">' + pad(mins) + '</span><span class="rs-countdown-label">m</span>' +
        '<span class="rs-countdown-box">' + pad(secs) + '</span><span class="rs-countdown-label">s</span>';
    }
    tick();
    var timer = setInterval(tick, 1000);
  }

  function replaceTextNode(node){
    var text = node.nodeValue;
    var re = /\[countdown\]([\s\S]*?)\[\/countdown\]/ig;
    if (!re.test(text)) return;
    re.lastIndex = 0;
    var frag = document.createDocumentFragment();
    var last = 0, match;
    while ((match = re.exec(text))) {
      if (match.index > last) frag.appendChild(document.createTextNode(text.slice(last, match.index)));
      var span = document.createElement('span');
      span.className = 'rs-countdown-shortcode';
      span.setAttribute('data-countdown-target', match[1].trim());
      span.setAttribute('aria-label', 'Pre-sale countdown');
      frag.appendChild(span);
      last = re.lastIndex;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }

  function walk(root){
    var walker = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node){
        if (!node.nodeValue || node.nodeValue.indexOf('[countdown]') === -1) return NodeFilter.FILTER_REJECT;
        var p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        if (/^(SCRIPT|STYLE|TEXTAREA|INPUT)$/i.test(p.tagName)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(replaceTextNode);
  }

  function init(){
    if (!document.body) return;
    addStyle();
    walk(document.body);
    document.querySelectorAll('.rs-countdown-shortcode').forEach(render);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();